<template>
  <v-container>
    <div class="d-flex align-center flex-wrap mb-2" style="gap: 20px" v-if="$root.acceso('FIRMAS')">
      <v-btn small color="primary" @click.stop="getItems">
        <v-icon left>mdi-reload</v-icon>
        {{ $t("common.recargar") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        
        small
        color="secondary"
        @click.stop="consentimientos($event)"
        type="button"
      >
        <v-icon left>mdi-microsoft-excel</v-icon>
        {{ $t("common.exportar_cons") }}
      </v-btn>
    </div>
    <div v-if="$root.acceso('FIRMAS')" class="mb-4">
      <v-card>
        <!-- search telefono -->
        <v-form>
          <v-text-field
            v-model="search"
            :label="$t('common.busqueda')"
            prepend-inner-icon="mdi-magnify"
            class="mx-2"
            clearable
          ></v-text-field>
          <table-filters
            :items="items"
            :headers="headers"
            @exportar-todos="exportarTodos"
          ></table-filters>
        </v-form>
      </v-card>

      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          class="elevation-1"
          item-key="id"
          dense
        >
          <template #item.fecha="{ item }">
            <span>{{ formatDate(item.fecha) }}</span>
          </template>
          <template #item.terminosAceptados="{ item }">
            <v-icon v-if="item.terminosAceptados">mdi-check</v-icon>
          </template>
          <template #item.recibirInformacion="{ item }">
            <v-icon v-if="item.recibirInformacion">mdi-check</v-icon>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-card outlined class="mb-4" v-if="!$root.acceso('FIRMAS')">
      <v-card-title class="primary--text">
        {{ $t("contratos.validar_consentimientos") }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field
          v-model="telefonosValidar"
          :label="$t('contratos.introduce_telefonos')"
          type="tel"
          clearable
          outlined
          textarea
          rows="4"
        ></v-text-field>
        <v-btn class="mt-2" color="primary" @click="validarTelefonos">
          <v-icon left>mdi-magnify</v-icon>
          {{ $t("contratos.validar") }}
        </v-btn>

        <v-list v-if="resultadosValidacion.length" class="mt-3">
          <v-list-item
            v-for="(item, index) in resultadosValidacion"
            :key="index"
            :class="item.existe ? 'success--text' : 'error--text'"
          >
            <v-list-item-icon>
              <v-icon>{{ item.existe ? "mdi-check" : "mdi-close" }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.telefono }} —
                {{
                  item.existe
                    ? $t("contratos.existe")
                    : $t("contratos.no_existe")
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { perColumnFilter, parseDate, jsonToCsv } from "@/utils/index.js";

export default {
  components: {
    EstadoContrato: () =>
      import("@/modules/contratos/components/EstadoContrato.vue"),
    TableFilters: () => import("@/components/TableFilters.vue"),
    ConfirmDialog: () => import("@/components/ConfirmDialog.vue"),
    AppTable: () => import("@/components/AppTable.vue"),
  },
  props: {
    _detailsId: String | Number,
  },
  data() {
    return {
      items: [],
      search: null,
      loading: false,
      telefonosValidar: "",
      resultadosValidacion: [],
      headers: [
        { text: "Fecha", value: "fecha" },
        { text: "IP", value: "ip" },
        { text: "Teléfono", value: "telefono" },
        { text: "Consentimiento", value: "terminosAceptados" },
        { text: "Información", value: "recibirInformacion" },
        // { text: "Navegador", value: "navegador" },
        // { text: "IP", value: "ip" },
      ],
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    parseDate,
    async validarTelefonos() {
      const colaboradorId = this.$store.getters.getTokenPayload.refcanal;

      if (!this.telefonosValidar.trim()) {
        this.$toast?.error(this.$t("contratos.no_hay_telefonos"));
        return;
      }

      const telefonos = this.telefonosValidar
        .split(/\s|,|\n/) 
        .map((t) => t.trim().replace(/^\+34/, ""))
        .filter(Boolean);

      this.resultadosValidacion = [];

      for (const telefono of telefonos) {
        try {
          const response = await axios.get(
            "/borradores/comparar_consentimiento",
            {
              params: {
                telefono,
                colaborador_id: colaboradorId,
              },
            }
          );

          const existe = response.data === true;

          this.resultadosValidacion.push({
            telefono,
            existe,
          });

          this.$toast?.success(
            `${
              existe
                ? this.$t("contratos.existe")
                : this.$t("contratos.no_existe")
            }`
          );
        } catch (error) {
          console.error("Error validando teléfono:", telefono, error);
          this.resultadosValidacion.push({
            telefono,
            existe: false,
          });

          this.$toast?.error(`${telefono} — ${this.$t("contratos.no_existe")}`);
        }
      }
    },
    async getItems() {
      this.loading = true;
      const { data } = await axios({
        method: "GET",
        url: `/consentimiento/consentimientos_colaborador`,
      });

      this.items = data;
      this.loading = false;
    },
    async consentimientos(event) {
      if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
      }

      this.loading = true;

      try {
        const response = await axios({
          method: "GET",
          url: `/consentimiento/consentimientos_colaborador`,
        });

        const consents = response.data;

        if (!Array.isArray(consents)) {
          console.error("La respuesta no contiene un array válido:", consents);
          return;
        }
        consents.forEach((consent) => {
          consent.navegador = consent.navegador.replace(/;/g, " ");
        });
        jsonToCsv(
          consents,
          [
            { text: "ID", value: "id" },
            { text: "Fecha", value: "fecha" },
            { text: "Teléfono", value: "telefono" },
            { text: "IP", value: "ip" },
            { text: "Consentimiento", value: "terminosAceptados" },
            { text: "Información", value: "recibirInformacion" },
            { text: "navegador", value: "navegador" },

            { text: "Ref", value: "ref" },
          ],
          this.$t("menu.consentimientos") +
            "_" +
            parseDate(Date.now(), false, false)
        );
      } catch (error) {
        console.error("Error cargando consentimientos:", error);
      } finally {
        this.loading = false;
      }
    },
    exportarTodos() {
      const getDatatype = (key) =>
        (this.headers.find((h) => h.value == key) || {}).dataType;

      const items = this.items.filter((con) =>
        Object.entries(con).every(([key, value]) =>
          perColumnFilter(value, this.inlineFilters[key], getDatatype(key))
        )
      );

      jsonToCsv(
        items,
        this.headers,
        this.$t("menu.facturas") + "_" + parseDate(Date.now(), false, false)
      );
    },
    openDraft(item) {
      this.$router.push(`/borradores/nuevo?id=${item.ref}`);
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>
